import type { InputNumberProps } from 'antd';

export function parseDecimalInput(value: string | number | undefined | null): number | null {
  if (value === undefined || value === null || value === '') {
    return null;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  const normalized = String(value).trim().replace(/\s/g, '').replace(',', '.');
  if (!normalized) {
    return null;
  }
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatDecimalDisplay(
  value: number | string | undefined | null,
  precision = 1
): string {
  if (value === undefined || value === null || value === '') {
    return '-';
  }
  const num = typeof value === 'number' ? value : parseDecimalInput(value);
  if (num === null) {
    return String(value);
  }
  return num.toFixed(precision).replace('.', ',');
}

export const decimalInputNumberProps: Pick<
  InputNumberProps,
  'decimalSeparator' | 'parser' | 'formatter'
> = {
  decimalSeparator: ',',
  parser: (value) => {
    const parsed = parseDecimalInput(value ?? '');
    return parsed === null ? ('' as unknown as number) : parsed;
  },
  formatter: (value) => {
    if (value === undefined || value === null || value === '') {
      return '';
    }
    return String(value).replace('.', ',');
  },
};
